import { render, staticRenderFns } from "./MonthEvents.vue?vue&type=template&id=5b4d825e&"
import script from "./MonthEvents.vue?vue&type=script&lang=js&"
export * from "./MonthEvents.vue?vue&type=script&lang=js&"
import style0 from "./MonthEvents.vue?vue&type=style&index=0&id=5b4d825e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports